const origin = typeof window !== 'undefined' ? window.location.origin : ''

const envApiUrl = import.meta.env.VITE_API_URL ?? origin
const envAuthApiUrl = import.meta.env.VITE_AUTH_API_URL ?? origin

export const apiUrl = envApiUrl
export const authApiUrl = envAuthApiUrl
